import { useQuery } from '@tanstack/react-query';
import { SITE_CONTEXT_CACHE_KEY } from './iwQueryClient';
import _ from 'lodash';

export function useStateKey() {
    const { data } = useQuery({
        queryKey: [SITE_CONTEXT_CACHE_KEY]
    });

    return _.get(data, 'data.state_key')!;
}
